<template>
	<div class="download-container">
		<div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div>
		<img class="logo" src="@/assets/icon/authAccount/logo.png" alt="五行商户LOGO">
		<div class="text-with-button">
			<img class="text" src="@/assets/icon/authAccount/text.png" alt="">
			<img class="btn" src="@/assets/icon/authAccount/btn.png" alt="" @click="handleAuth">
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	export default {
		name: "authAccount",
		data() {
			return {};
		},
		created() {
			this.$parent.footer('authAccount', false);
		},
		methods: {
			handleAuth() {
				console.log("立即认证按钮被点击");
				this.$router.push({
					path: '/onlinePayment',
					query: {
						id: 0
					}
				});
			}
		}
	};
</script>

<style scoped>
	.download-container {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		color: #b22222;
		font-family: "微软雅黑", sans-serif;
		height: 100vh;
		width: 10rem;
		background: url(~@/assets/icon/authAccount/bg.png) 100% no-repeat;
		background-size: 100% 100%;
	}

	.header-bar {
		width: 100%;
		padding: 4.26667vw;
		display: flex;
		align-items: center;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.logo {
		width: 80%;
	}

	.text-with-button {
		position: relative;
		width: 90%;
		margin-top: 15%;
	}

	.text {
		width: 100%;
		display: block;
	}

	.btn {
		position: absolute;
		width: 30%;
		left: 50%;
		top: 85%;
		transform: translateX(-50%);
		cursor: pointer;
	}
</style>